<template>
  <validation-observer ref="form">
    <div class="card card-shadow card-rounded border-0 mb-4" v-if="!emailSending">
      <div v-if="errors.length > 0" class="alert alert-danger">
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
      </div>
      <validation-provider vid="email" rules="required|email" v-slot="{ errors }">
        <div class="card-body">
          <p class="small">{{ $t(`SendDocumentForm.${type}.text`) }}</p>
          <div class="form-group">
            <label for="userEmail" class="sr-only">{{ $t('SendDocumentForm.email') }}</label>
            <input type="text"
                   id="userEmail"
                   class="form-control form-control-lg"
                   :class="{'is-invalid': errors.length}"
                   inputmode="email"
                   :placeholder="$t('SendDocumentForm.yourEmail') "
                   v-model="email"
                   :disabled="!canChangeEmail"
            >
            <span class="invalid-feedback" v-if="errors.length">{{ errors[0] }}</span>
          </div>
          <button id="button-send-document" class="btn btn-primary btn-lg btn-block" @click="send()">
            {{ $t(`SendDocumentForm.${type}.send`) }}
          </button>
        </div>
      </validation-provider>
    </div>
    <div class="card card-shadow card-rounded border-0 mb-4" v-else>
      <div class="card-body text-center">
        <spinner></spinner>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import store from '@shared/store'

export default {
  name: 'SendDocumentForm',
  props: ['reference', 'type'],
  data() {
    return {
      email: store.state.currentUser.email,
      emailSending: false,
      errors: []
    }
  },
  methods: {
    sendToEmail() {
      this.emailSending = true
      this.$http.post(`/api/loans/${this.reference}/email/${this.type}`, { email: this.email })
          .then(() => {
            this.$successToast(this.$t(`SendDocumentForm.${this.type}.wasSent.title`), this.$t(`SendDocumentForm.${this.type}.wasSent.message`))
            if (this.canChangeEmail) {
              this.email = null
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors
          })
          .finally(() => {
            this.emailSending = false
          })
    },
    send() {
      this.$refs.form.validate().then(this.onValidationDone)
    },
    onValidationDone(isSuccess) {
      if (isSuccess) {
        this.sendToEmail()
      }
    }
  },
  computed: {
    canChangeEmail() {
      return !this.$configuration.newCoreEnabled
    }
  }
}
</script>
